import { render, staticRenderFns } from "./PanelRequest.vue?vue&type=template&id=51972d6d&"
import script from "./PanelRequest.vue?vue&type=script&lang=js&"
export * from "./PanelRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports